export default __webpack_public_path__ + "static/media/mysteryBet.3644ec40.png";